import React from 'react';
import { connect } from 'react-redux';

import { logOut } from '../../action/auth_action';

//User logout
const Logout =props =>{
    return(
        <div className="dash_header_right" onClick={props.logOut}>
        <a>LOGOUT <img src="../../assets/images/logout.svg" className="dash_logout" /></a>
      </div>
    )
}

export default connect(null, {
    logOut
  })(Logout);


// WEBPACK FOOTER //
// ./web/components/common/logout.js